<template>
  <v-navigation-drawer right app v-model="drawer" temporary>
    <v-list dense>
       <v-container class="pa-2">
     <div>
      <v-layout row wrap>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Branch_List"
            :label="$t('branch')"
            item-text="name"
            item-value="code"
            v-model="branchSelect"
            outline
            hide-details
            @input="selectbranch()"
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            class="ma-0"
            :items="Department_List"
            :label="$t('Department')"
            item-text="name"
            item-value="code"
            v-model="departmentSelect"
            outline
            hide-details
            @input="selectbranch()"
          />
        </v-flex>
        <v-flex xs12 class="pa-1">
          <v-select
            :items="Position_List"
            :label="$t('Position')"
            item-text="name"
            item-value="code"
            v-model="positionSelect"
            outline
            hide-details
            @input="selectbranch()"
          />
        </v-flex>
      </v-layout>
    </div>

     </v-container>
    </v-list>
  </v-navigation-drawer>
</template>


<script>
/* eslint-disable */
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { setTimeout } from 'timers';
export default {
  props: {
    json_data: Object
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
         this.openfilter(val.status);
      } else {
        
      }
    }
    
  },
   data: () => ({
      mini: false,
      drawer: false,
      datedialog: false,
      formatdate: 0,
      selectitems: [
        { txt: "None", val: "" },
        { txt: "ThisMount", val: 0 },
        { txt: "ThisWeek", val: 1 },
        { txt: "Today", val: 2 },
        { txt: "LastWeek", val: 3 },
        { txt: "LastMount", val: 4 }
      ],
      ChoiceSelected: ""
    }),
 
  computed: {
    ...mapGetters("filter", ["getShowFilter"]),
    ...mapState("app", ["formatDates"]),
    ...mapGetters("app", ["getShowFilterButton"]),
    ...mapState("filter", [
      "loading",
      "Branch_List",
      "Department_List",
      "Position_List",
      "Errormsg",
      "SelectBranch",
      "SelectDepartment",
      "SelectPosition",
      "FromDate",
      "ToDate",
      "showFilter"
    ]),
     branchSelect: {
      get() {
        return this.SelectBranch;
      },
      async set(value) {
        await this.getDepartment({ branch: value });
      }
    },
    departmentSelect: {
      get() {
        return this.SelectDepartment;
      },
      async set(value) {
        await this.getPosition({ department: value });
      }
    },
    positionSelect: {
      get() {
        return this.SelectPosition;
      },
      async set(value) {
        await this.selectedPosition({ data: value });
      }
    },
  },
   mounted: function() {
    if (this.Branch_List.length == 0) {
      this.getBranch();
    }
  },
  methods: {
    ...mapActions("filter", ["getBranch", "getDepartment", "getPosition"]),
    ...mapActions("app", ["getFormatDate"]),
    ...mapMutations("filter", [
      "selectedPosition",
      "selectedFormDate",
      "selectedToDate"
    ]),
    openfilter(status){
        this.drawer = status;
         console.log( this.drawer)
    },
    selectbranch(){
      let v = this;
      setTimeout(function() { 
     if(this.branchSelect != 'ALL' && this.departmentSelect == 'ALL' && this.SelectPosition == 'ALL'){
        v.$emit("set");
     }
     else if(this.branchSelect != 'ALL' && this.departmentSelect != 'ALL' && this.SelectPosition == 'ALL'){
         v.$emit("set");
     }
    else if(this.branchSelect != 'ALL' && this.departmentSelect != 'ALL' && this.SelectPosition != 'ALL'){
         v.$emit("set");
     }
     else{
       v.$emit("set"); 
     }
     }, 3000);
     
    }
  },
  created: function() {
    this.formatdate = this.formatDates;
    this.$emit("set");

  }
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Prompt");

h2,
span,
p {
  font-family: "Prompt", sans-serif;
}

/* mobile  ----------- */
@media screen and (min-width: 320px) and (max-width: 640px) {
  #header_message {
    visibility: hidden;
    clear: both;
    float: left;
    width: 28%;
    display: none;
    margin-right: 0px !important;
  }
  .container-fluid {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* tablet  ----------- */
@media screen and (max-width: 768px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none1 {
    display: none;
  }
}

/* ipad pro  ----------- */
@media screen and (min-width: 1024px) and (max-width: 1366px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
}

@media screen and (min-width: 1024px) and (max-width: 3000px) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: none;
  }
}

/* iPads (landscape) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
/* iPads (portrait) ----------- */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) {
  #header_message {
    margin: 0px 25px 0px 0px !important;
  }
  .display_none {
    display: block;
  }
}
</style>

